import logoImg from '../images/nav bar logo.png';
import banner1 from '../images/banner1.jpg';
import banner2 from '../images/banner2.jpg';
import banner3 from '../images/banner3.jpg';
import banner4 from '../images/banner4.jpg';
import banner5 from '../images/banner5.jpg';
import banner6 from '../images/banner6.jpg';

import chairmanImg from '../images/chairman.png';
import viceChairmanImg from '../images/vice chairman.png';
import presidentImg from '../images/president.png';
import vpEmeritaaImg from '../images/emritha.jpeg';

import gdSinghImg from '../images/prof.dr.sir GD singh.png';
import drRomeshImg from '../images/hh prof.dr.sir.romesh.png';
import mrsCharmaineImg from '../images/msr.chamaine.png';

export const defaultSiteData = {
  siteName: 'United Nations Global Development Organization',
  tagline: 'Peace, human rights, sustainable development and global partnerships',
  logo: logoImg,
  hero: {
    title: 'Volunteer for a better world',
    subtitle: 'We build partnerships for peace, social development, education, and humanitarian action.',
    ctaText: 'Explore our mission',
    ctaLink: '/about'
  },
  bannerSlides: [
    {
      id: 'slide-1',
      image: banner1,
      title: 'Global Action for Peace & Development',
      subtitle: 'Facilitating United Nations Sustainable Development Goals globally across communities.',
      ctaText: 'Explore Our Mission',
      ctaLink: '/about'
    },
    {
      id: 'slide-2',
      image: banner2,
      title: 'Human Rights & Social Equity',
      subtitle: 'Advancing dignity, community empowerment, and equal opportunities worldwide.',
      ctaText: 'Learn More',
      ctaLink: '/united-nations/un-human-rights-declaration'
    },
    {
      id: 'slide-3',
      image: banner3,
      title: 'Sustainable Development Goals',
      subtitle: 'Mobilizing local initiatives and international partnerships for Agenda 2030.',
      ctaText: 'SDG Explorer',
      ctaLink: '/united-nations/sdg-interactive'
    },
    {
      id: 'slide-4',
      image: banner4,
      title: 'Infrastructural Funding & Growth',
      subtitle: 'Structuring donor financing for healthcare, housing, energy, and civic projects.',
      ctaText: 'Our Projects',
      ctaLink: '/projects'
    },
    {
      id: 'slide-5',
      image: banner5,
      title: 'Peace Education & Global Diplomacy',
      subtitle: 'Empowering future leaders through UN University for Global Peace programs.',
      ctaText: 'Academic Vision',
      ctaLink: '/united-nations/un-university-for-global-peace'
    }
  ],
  contact: {
    email: 'info@ungdo.org',
    phone: '+1 (000) 000-0000',
    location: 'United Nations Global Development Organization Head Office,\nDelaware, USA',
    facebook: 'https://web.facebook.com/unglobaldevorg',
    hoursWeekdays: 'Monday to Friday: 9:00AM–5:00PM',
    hoursWeekends: 'Saturday & Sunday: 11:00AM–3:00PM'
  },
  navItems: [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About Us' },
    { to: '/projects', label: 'Projects' },
    { to: '/united-nations', label: 'United Nations' },
    { to: '/augp-usa', label: 'AUGP USA' },
    { to: '/contact', label: 'Contact' }
  ],
  about: {
    heading: 'About the organization',
    summary: 'The United Nations Global Development Organization (UNGDO) is a mission-driven international organization dedicated to advancing peace, human rights, social development, and sustainable partnerships across communities, nations, and institutions.',
    mission: 'To support awareness of global development priorities, empower communities, and strengthen partnerships for social, economic, and environmental resilience.'
  },
  leadership: [
    {
      id: 'lead-1',
      role: 'Chairman',
      name: 'His Eminence Prof. Dr. Sir Madhu Krishan',
      titleDetails: '',
      image: chairmanImg,
      bio: [
        'His Eminence Prof. Dr. Madhu Krishan is an Engineer, Scientist and Global Diplomat who is the Founder and Chairman of the Academy of Universal Global Peace- AUGP which is registered with the United Nations. AUGP is affiliated with DMPP Albania, United Nations, United Nations Global Compact & European Commission and World Peace Organization. He is also the President and Rector of United Nations University For Global Peace.',
        'Dr.Madhu is the Honorary Chairman & Goodwill Ambassador of Diplomatic Mission Peace And Prosperity – Albania; Ambassador of The Kingdom of Buyoro – Kitara (ARKBK) – Uganda; Ambassador of International Blue Cross – United Kingdom; Ambassador of World Parliament of Peace & Security.',
        'He has won several awards, such as, Bharath Excellence Award and Gold Medal 2006, Rashtriya Jewel Award and Gold Medal 2006 & the first ever Indian to get "USA President\'s Life Time Achievement Award" For 30 years of dedicated services in more than 77 countries. Earlier he received the best scientist award from USA.'
      ]
    },
    {
      id: 'lead-2',
      role: 'Vice Chairman',
      name: 'Prof. Dr. Sir Lakshman Madurasinghe',
      titleDetails: '',
      image: viceChairmanImg,
      bio: [
        'Prof. Dr Lakshman Madurasinghe is a Lawyer, Behavioural Scientist, Educationist, Strategist and Author of four books including Clinical Psychology, Buddhism & Christianity. He is an Academic Board Member of EDU Brussels accredited to European Parliament and the Chancellor of the United Nations University For Global Peace and Vice Chancellor of AUGP.',
        'He is an Ambassador at Large in United Refugee Green Council and a Consultant on socioeconomic development to Vassili Group in Cyprus, EU. He is the Chairman of the Eco-tourism Development project, Chairman infrastructural funding and Vice Chairman of Way to Comfort NGO.',
        'He is a life member of the Cambridge University Society of Cambridge University, England, and its former Treasurer in Sri Lanka: World Jurists Association, USA: International Council of Psychologists, USA and Institute of Counselling, Glasgow.'
      ]
    },
    {
      id: 'lead-3',
      role: 'President',
      name: 'Dr. Tharindu Wijenayake',
      titleDetails: 'GG, AJP GIA (London), M.B.A (London): D Dipl&SD (USA)',
      image: presidentImg,
      bio: [
        'Dr. Tharindu Wijenayake is an Entrepreneur, Gemologist, Philanthropist and a young energetic youth leader. He hails from a generation of patrons of social services done with their own will & funds for the Sri Lankan society. Heading the WCM youth ministry and media he is a mentor to thousands of youth.',
        'A catalyst for change to foster & promote the well-being of communities. International President- United Nations Global Development Organization – USA, Registered with United Nations, Vice Chairman- Sanasumata Maga (Way To Comfort) NGO, International Director of Youth Affairs- Academy Of Universal Global Peace – USA, Registered With United Nations, CEO- Kavinda Enterprises Pvt Ltd, Director General- WCM Media, Regional head Sri Lanka – World Peace & Diplomacy Organization (WPDO).'
      ]
    },
    {
      id: 'lead-4',
      role: 'Vice President',
      name: 'Dr. Emeritaa Wijenayake (Fernando)',
      titleDetails: '',
      image: vpEmeritaaImg,
      bio: [
        'Dr. Emeritaa Wijenayake (Fernando) serves as Vice President of the United Nations Global Development Organization (UNGDO), distinguished by a multidisciplinary career encompassing entrepreneurship, strategic communications, international events, media, business development, and the creative industries.',
        'Her professional journey reflects a commitment to visionary leadership, innovation, international engagement, and meaningful social impact. With a strong aptitude for strategic relationship-building and public representation, Dr. Emeritaa engages with diverse professional and international communities to foster collaboration and create new avenues for opportunity.',
        'In her leadership capacity at UNGDO, Dr. Emeritaa is dedicated to advancing sustainable development, entrepreneurship, education, empowerment, and inclusive growth, with particular emphasis on initiatives that inspire women and youth to become catalysts for positive and lasting change.'
      ]
    }
  ],
  internationalGovernors: [
    {
      id: 'gov-1',
      role: 'International Governor',
      name: 'Prof. Dr. Sir GD Singh',
      titleDetails: '',
      image: gdSinghImg,
      bio: [
        'Prof.Dr.Sir G D Singh is Chair of the Confederation of International Accreditation Commission- CIAC, Global Board, serving as President of CIAC- Global since Dec 2009. GD is the Founder & Managing Director of Unified Brainz Group Holdings Inc. Prior to his entrepreneurial venture with UBGHI, a dynamic personality infused with entrepreneurial spirit GD has been actively playing role in leading the Top Management & board of advisory as a Management Consultant to Leading Companies in India & Abroad; His far-sighted vision and keen business acumen provide the necessary leadership and impetus to the group activities.',
        'He is the President of the World Peace and Diplomacy Organisation-WPDO registered with the United Nations.'
      ]
    }
  ],
  advisors: [
    {
      id: 'adv-3',
      role: 'Advisor',
      name: 'HH Prof. Dr. Sir. Romesh Jayasinghe',
      titleDetails: '',
      image: drRomeshImg,
      bio: [
        'Prof. Dr.Sir Romesh Jayasinghe is a Psychologist and the President of the Institute of Mental Health SL. He is the Executive Director and Peace Mediator at International Special Court of Arbitration and Human Rights IGC. He is also the Vice President and Ambassador at Large Extraordinary for South Asia and High Commissioner for Social Economy and Mental Health Science, Sri Lanka at International Commission of Diplomatic Relations Human Rights and Peace.'
      ]
    },
    {
      id: 'adv-4',
      role: 'Advisor',
      name: 'Mrs. Charmaine Eheliyagoda Madurasinghe',
      titleDetails: '',
      image: mrsCharmaineImg,
      bio: [
        'Mrs. Charmaine Eheliyagoda Madurasinghe is an Attorney-at-Law of the Supreme Court of Sri Lanka and a Notary Public. She is a Life Member of the Bar Association of Sri Lanka. She is also a Life Member of Colombo Law Society and a Member of the Executive Committee of Women Lawyers Association. Charmaine served two terms ( 2006-2009 and 2012-2015) as a Commission Member of the National Police Commission of Sri Lanka. She is an Advisor of Sanasumata Maga (Way To Comfort) NGO in Sri Lanka and a Senate Member of the United Nations University For Global Peace.',
        'Charmaine is a multi-talented, results-oriented, senior professional with excellent language skills and wide experience in planning, strategy, administration and people management, and for seven years she served as the Manager Legal HR and Administration at Sumanagiri Lanka Ltd-owning company of Cocoon Resorts in Induruwa, Kosgoda & Nuwera Eliya. She is a past pupil of St Bridget\'s Convent, Colombo, and the Vice President of the Past Pupil\'s Association ( 2015/16). She is also a Graduate of the International Institute of Theological Studies, USA. which is affiliated to the Middle East and South Asia Graduate School of Theology, a faculty of Hebron Eco University.'
      ]
    }
  ],
  focusAreas: [
    'Global peace and security',
    'Human rights education and advocacy',
    'Zero hunger, quality health, and education',
    'Climate action and sustainable cities',
    'Inclusive partnerships and development projects'
  ],
  stats: [
    { value: '15+', label: 'Years of community engagement' },
    { value: '20+', label: 'Programs and initiatives' },
    { value: '50+', label: 'Community partnerships' },
    { value: '100%', label: 'Focused on human dignity' }
  ],
  projects: [
    {
      id: 'p1',
      title: 'Community Empowerment and Resilience',
      tag: 'Human Development',
      image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1200&q=80',
      shortDescription: 'Helping communities build resilient infrastructure and access essential services.',
      description: 'This initiative promotes practical engagement in education, health, livelihoods, food security, and social inclusion while strengthening local ownership.'
    },
    {
      id: 'p2',
      title: 'Global Peace and Rights Advocacy',
      tag: 'Peace & Rights',
      image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1200&q=80',
      shortDescription: 'Supporting the promotion of peace, justice, and human rights awareness worldwide.',
      description: 'We help amplify advocacy, policy awareness, and education efforts that promote dignity, fairness, inclusion, and peaceful collaboration across regions.'
    },
    {
      id: 'p3',
      title: 'Sustainable Development Goals',
      tag: 'SDG Action',
      image: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1200&q=80',
      shortDescription: 'Connecting local action with the global commitment to the SDGs.',
      description: 'Our SDG-focused work supports climate resilience, quality education, gender equality, health access, and partnerships that drive long-term progress.'
    }
  ],
  gallery: [
    {
      id: 'g1',
      title: 'Leadership event',
      shortDescription: 'A leadership gathering focused on inclusive global partnerships and peace-building efforts.',
      image: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1200&q=80'
    },
    {
      id: 'g2',
      title: 'Community gathering',
      shortDescription: 'Community members coming together to share ideas, support local initiative, and build collective progress.',
      image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1200&q=80'
    },
    {
      id: 'g3',
      title: 'Human rights campaign',
      shortDescription: 'A public advocacy moment highlighting justice, dignity, and human rights awareness.',
      image: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1200&q=80'
    },
    {
      id: 'g4',
      title: 'SDG awareness',
      shortDescription: 'Education and outreach focused on sustainable development goals and shared action.',
      image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1200&q=80'
    }
  ],
  unitedNations: {
    heading: 'United Nations',
    intro: 'We share information on global peace education, human rights, and SDG-focused development strategies with a strong commitment to international cooperation.',
    links: [
      { label: 'UN University for Global Peace', to: '/united-nations/un-university-for-global-peace' },
      { label: 'UN Human Rights Declaration', to: '/united-nations/un-human-rights-declaration' },
      { label: 'SDG Interactive', to: '/united-nations/sdg-interactive' }
    ]
  }
};
